import React from 'react';
import { AppLayout, Header } from '@cloudscape-design/components';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import './App.css';
import { Navigation } from './components/Navigation';
import { Players } from './components/Players';
import { CurrentGame } from './components/CurrentGame';

export const App: React.FC = () => {
  return (
    <AppLayout
      contentHeader={<Header variant="h2">Game Companion</Header>}
      content={
        <Routes>
          <Route path="/players" element={<Outlet />}>
            <Route index element={<Players />} />
          </Route>
          <Route path="/gc" element={<Outlet />}>
            <Route path="current-game" element={<CurrentGame />} />
            <Route path="*" element={<Navigate to="current-game" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/players" replace />} />
        </Routes>
      }
      navigation={<Navigation />}
      toolsHide={true}
    />
  );
};
